export const ENDPOINTS_SELECTOR_PLANTA = {
  GET_DISTRIBUTION_SAP_MOTIVES: "/copec-api-planificador-motivo-sap",
  GET_ORDERS_SAP_MOTIVES: "/copec-api-planificador-info-prog-sap",
};
